/**
 * Few Moda — global Rebuy product-card bridge
 * Enhances any .rebuy-product-block with FM pricing + CTA states.
 * Pure helpers live on window.FM.rebuyCard for reuse outside the theme host.
 */
(function () {
  'use strict';

  var VIEW = 'fm-rebuy-data';
  var ENHANCED_ATTR = 'data-fm-rebuy-enhanced';
  var cache = Object.create(null);

  window.FM = window.FM || {};

  function pctToRatio(pct) {
    var n = Number(pct);
    if (isNaN(n)) return 1;
    return (100 - n) * 0.01;
  }

  function formatMoney(cents) {
    var amount = Number(cents) / 100;
    if (isNaN(amount)) return '';
    var pricing = (window.FM.config && window.FM.config.pricing) || {};
    if (pricing.moneyWithoutTrailingZeros && amount % 1 === 0) {
      return '$' + Math.round(amount).toLocaleString('en-US');
    }
    return (
      '$' +
      amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function tagList(product) {
    return Array.isArray(product.tags) ? product.tags : [];
  }

  function hasTagContaining(tags, needle) {
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).indexOf(needle) !== -1) return true;
    }
    return false;
  }

  function summerSaleTier(tags) {
    if (hasTagContaining(tags, 'SummerSale60')) return '60';
    if (hasTagContaining(tags, 'SummerSale50')) return '50';
    if (hasTagContaining(tags, 'SummerSale40')) return '40';
    if (hasTagContaining(tags, 'SummerSale30')) return '30';
    return null;
  }

  function inCollection(product, id, handle) {
    var cols = product.collections || [];
    for (var i = 0; i < cols.length; i++) {
      if (id && cols[i].id === id) return true;
      if (handle && cols[i].handle === handle) return true;
    }
    return false;
  }

  /**
   * Mirror custom-specialcollections.liquid ratio selection.
   * Returns { memberDiscountRatio, discountRatio, standardMemberRatio, memberPricingOnly, promoBadge }
   */
  function resolvePricing(product) {
    var cfg = (window.FM.config && window.FM.config.pricing) || {};
    var standardMemberRatio = cfg.memberPriceMultiplier != null ? cfg.memberPriceMultiplier : 0.4;
    var memberDiscountRatio = 1;
    var discountRatio = 1;
    var memberPricingOnly = !!product.member_exclusive;
    var promoBadge = '';
    var tags = tagList(product);

    if (hasTagContaining(tags, 'member_discount|exempt') || product.template_suffix === 'gift-card-product') {
      standardMemberRatio = 1;
    }

    var sale = cfg.sale || {};
    var clearance = cfg.clearance || {};
    var mefs = cfg.mefs || {};
    var summer = cfg.summerSale || {};

    if (inCollection(product, sale.collectionId, sale.collectionHandle)) {
      memberDiscountRatio = pctToRatio(sale.memberDiscountPct);
      discountRatio = pctToRatio(sale.nonMemberDiscountPct);
      promoBadge = sale.promoBadge || '';
    } else if (inCollection(product, clearance.collectionId, clearance.collectionHandle)) {
      memberDiscountRatio = pctToRatio(clearance.memberDiscountPct);
      discountRatio = pctToRatio(clearance.nonMemberDiscountPct);
      promoBadge = clearance.promoBadge || '';
    } else if (
      (function () {
        var tierEarly = summerSaleTier(tags);
        var inSummerCol =
          inCollection(product, null, 'summer-sale') ||
          inCollection(product, summer['60'] && summer['60'].collectionId, summer['60'] && summer['60'].collectionHandle) ||
          inCollection(product, summer['50'] && summer['50'].collectionId, summer['50'] && summer['50'].collectionHandle) ||
          inCollection(product, summer['40'] && summer['40'].collectionId, summer['40'] && summer['40'].collectionHandle) ||
          inCollection(product, summer['30'] && summer['30'].collectionId, summer['30'] && summer['30'].collectionHandle);
        if (!(inSummerCol || tierEarly)) return false;
        var tier = tierEarly;
        if (tier && summer[tier]) {
          memberDiscountRatio = pctToRatio(summer[tier].memberDiscountPct);
          discountRatio = pctToRatio(summer[tier].nonMemberDiscountPct);
          promoBadge = summer[tier].promoBadge || tier + '% Off';
          return true;
        }
        // In summer collection but no tier tag yet — fall through to other rules
        return false;
      })()
    ) {
      // ratios already assigned in IIFE
    } else if (inCollection(product, mefs.collectionId, mefs.collectionHandle)) {
      memberDiscountRatio = pctToRatio(mefs.memberDiscountPct);
      discountRatio = pctToRatio(mefs.nonMemberDiscountPct);
      promoBadge = mefs.promoBadge || '';
    } else if (cfg.memberPreviewActive && inCollection(product, cfg.memberPreviewCollectionId, null)) {
      memberDiscountRatio = 1;
      discountRatio = 0.4;
    }

    // Tag fallback when summer-sale collections missing from product.collections
    if (memberDiscountRatio === 1 && discountRatio === 1) {
      var fallbackTier = summerSaleTier(tags);
      if (fallbackTier && summer[fallbackTier]) {
        memberDiscountRatio = pctToRatio(summer[fallbackTier].memberDiscountPct);
        discountRatio = pctToRatio(summer[fallbackTier].nonMemberDiscountPct);
        promoBadge = summer[fallbackTier].promoBadge || fallbackTier + '% Off';
      }
    }

    return {
      memberDiscountRatio: memberDiscountRatio,
      discountRatio: discountRatio,
      standardMemberRatio: standardMemberRatio,
      memberPricingOnly: memberPricingOnly,
      promoBadge: promoBadge
    };
  }

  function buildPriceHtml(retailCents, pricing) {
    var memberSale = Math.round(retailCents * pricing.memberDiscountRatio * pricing.standardMemberRatio);
    var memberBase = Math.round(retailCents * pricing.standardMemberRatio);
    var retailSale = Math.round(retailCents * pricing.discountRatio);
    var onSale = pricing.memberDiscountRatio !== 1 || pricing.discountRatio !== 1;
    var showRetail = !pricing.memberPricingOnly && pricing.standardMemberRatio !== 1;
    var parts = [];

    parts.push('<div class="fm-rebuy-price' + (onSale ? ' fm-rebuy-price--sale' : '') + '">');
    parts.push('<span class="fm-rebuy-price__member">');
    if (pricing.memberDiscountRatio !== 1) {
      parts.push(
        '<span class="fm-rebuy-price__sale">' +
          formatMoney(memberSale) +
          '</span> <span class="fm-rebuy-price__compare fm-rebuy-price__compare--member">' +
          formatMoney(memberBase) +
          '</span>'
      );
      if (showRetail) parts.push(' Member');
    } else {
      parts.push(formatMoney(memberBase));
      if (showRetail) parts.push(' Member');
    }
    parts.push('</span>');

    if (showRetail) {
      parts.push('<span class="fm-rebuy-price__sep">|</span>');
      parts.push('<span class="fm-rebuy-price__retail">');
      if (pricing.discountRatio !== 1) {
        parts.push(
          '<span class="fm-rebuy-price__sale">' +
            formatMoney(retailSale) +
            '</span> <span class="fm-rebuy-price__compare">' +
            formatMoney(retailCents) +
            '</span> Retail'
        );
        if (pricing.promoBadge) {
          parts.push(
            ' <span class="fm-rebuy-price__badge">(' + pricing.promoBadge + ')</span>'
          );
        }
      } else {
        parts.push(formatMoney(retailCents) + ' Retail');
      }
      parts.push('</span>');
    }
    parts.push('</div>');
    return parts.join('');
  }

  function isMemberActive() {
    try {
      if (window.FM && window.FM.state && window.FM.state.membership) {
        return !!window.FM.state.membership.active;
      }
    } catch (e) {}
    var el = document.getElementById('fm-state');
    return !!(el && el.getAttribute('data-fm-active') === 'true');
  }

  function resolveCta(product, variant) {
    if (product.member_exclusive && !isMemberActive()) {
      return { state: 'member-exclusive', label: 'Member Exclusive' };
    }
    if (!variant || !variant.available) {
      return { state: 'sold-out', label: 'Sold out' };
    }
    var isPreorderProduct = product.template_suffix === 'preorder';
    if (isPreorderProduct && variant.preorder_active) {
      return { state: 'preorder', label: 'Preorder', url: product.url };
    }
    return { state: 'quick-buy', label: 'Quick Add' };
  }

  /**
   * Rebuy templates hardcode itemImage(..., '400x400') — a small square crop.
   * PLP cards request width-only 533/720/940. Rewrite Shopify CDN URLs to match.
   */
  var IMAGE_MIN_WIDTH = 533;
  var IMAGE_SRC = '720x';
  var IMAGE_SRCSET = [
    { size: '533x', w: 533 },
    { size: '720x', w: 720 },
    { size: '940x', w: 940 }
  ];
  var IMAGE_SIZES =
    '(min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';

  function shopifyImageWidth(url) {
    if (!url) return 0;
    var suffix = String(url).match(/_(\d+)x(\d+)?\.(?:png|jpe?g|webp|gif)/i);
    if (suffix) return Number(suffix[1]);
    var query = String(url).match(/[?&]width=(\d+)/i);
    if (query) return Number(query[1]);
    return 0;
  }

  function shopifySizedUrl(url, size) {
    if (!url) return url;
    var next = String(url);
    if (/_(\d+)x(\d+)?\.(?:png|jpe?g|webp|gif)/i.test(next)) {
      next = next.replace(/_(\d+)x(\d+)?(\.(?:png|jpe?g|webp|gif))/i, '_' + size + '$3');
    }
    if (/[?&]width=\d+/i.test(next)) {
      next = next.replace(/([?&])width=\d+/gi, '$1width=' + parseInt(size, 10));
    }
    next = next.replace(/[?&]height=\d+/gi, '');
    next = next.replace(/\?&/, '?').replace(/[?&]$/, '');
    return next;
  }

  function upgradeCardImages(block) {
    if (!block || block._fmUpgradingImgs) return;
    block._fmUpgradingImgs = true;
    try {
      var imgs = block.querySelectorAll(
        '.rebuy-product-media img, .rebuy-product-image img, .rebuy-product-image-trigger img'
      );
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        var raw = img.getAttribute('src') || img.getAttribute('data-src') || '';
        if (!raw || raw.indexOf('cdn.shopify.com') === -1) continue;
        if (shopifyImageWidth(raw) >= IMAGE_MIN_WIDTH) continue;

        var src = shopifySizedUrl(raw, IMAGE_SRC);
        var srcset = [];
        for (var s = 0; s < IMAGE_SRCSET.length; s++) {
          srcset.push(shopifySizedUrl(raw, IMAGE_SRCSET[s].size) + ' ' + IMAGE_SRCSET[s].w + 'w');
        }
        img.setAttribute('src', src);
        img.setAttribute('srcset', srcset.join(', '));
        img.setAttribute('sizes', IMAGE_SIZES);
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      }
    } finally {
      block._fmUpgradingImgs = false;
    }
  }

  window.FM.rebuyCard = {
    formatMoney: formatMoney,
    resolvePricing: resolvePricing,
    buildPriceHtml: buildPriceHtml,
    resolveCta: resolveCta,
    isMemberActive: isMemberActive,
    shopifySizedUrl: shopifySizedUrl,
    upgradeCardImages: upgradeCardImages,
    applyCollectionBadge: applyCollectionBadge
  };

  function extractHandle(block) {
    var link =
      block.querySelector('.rebuy-product-title-link') ||
      block.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=' + VIEW, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json, text/plain, */*' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('fm-rebuy-data ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var cleaned = text.replace(/^\uFEFF/, '').trim();
        // Theme may wrap JSON; take first { ... } object
        var start = cleaned.indexOf('{');
        var end = cleaned.lastIndexOf('}');
        if (start === -1 || end === -1) throw new Error('invalid fm-rebuy-data');
        return JSON.parse(cleaned.slice(start, end + 1));
      })
      .catch(function (err) {
        delete cache[handle];
        throw err;
      });
    return cache[handle];
  }

  function sizeOption(product) {
    var options = product.options || [];
    if (!options.length) return null;
    for (var i = 0; i < options.length; i++) {
      if (/size/i.test(options[i].name || '')) return options[i];
    }
    // Fashion cards: last option is usually Size when Color + Size
    return options.length > 1 ? options[options.length - 1] : options[0];
  }

  function sizeOptionIndex(product) {
    var opt = sizeOption(product);
    if (!opt) return -1;
    var options = product.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].name === opt.name) return i;
    }
    return -1;
  }

  function valueAvailable(product, sizeValue) {
    var idx = sizeOptionIndex(product);
    if (idx < 0) return false;
    return (product.variants || []).some(function (v) {
      return v.available && v.options && v.options[idx] === sizeValue;
    });
  }

  function findVariant(product, block) {
    var variants = product.variants || [];
    if (!variants.length) return null;

    var checked = block.querySelector('.fm-rebuy-size-picker input[type="radio"]:checked');
    if (checked) {
      var sizeValue = checked.value;
      var idx = sizeOptionIndex(product);
      var match =
        variants.find(function (v) {
          return v.available && v.options && v.options[idx] === sizeValue;
        }) ||
        variants.find(function (v) {
          return v.options && v.options[idx] === sizeValue;
        });
      if (match) return match;
    }

    // Fallback: leftover Rebuy controls
    var rebuyChecked = block.querySelector(
      '.rebuy-product-options input[type="radio"]:checked, input.rebuy-size-input:checked'
    );
    if (rebuyChecked) {
      var value = (rebuyChecked.value || '').trim();
      var byOption = variants.find(function (v) {
        return (
          v.title === value ||
          (v.options && v.options.indexOf(value) !== -1) ||
          String(v.id) === value
        );
      });
      if (byOption) return byOption;
    }

    var select = block.querySelector('.rebuy-product-options select, select.rebuy-select');
    if (select && select.value) {
      var selected = String(select.value);
      var byId = variants.find(function (v) {
        return String(v.id) === selected;
      });
      if (byId) return byId;
    }

    return (
      variants.find(function (v) {
        return v.available;
      }) || variants[0]
    );
  }

  function syncRebuySelect(block, variant) {
    if (!variant) return;
    var select = block.querySelector('.rebuy-product-options select, select.rebuy-select');
    if (!select) return;
    var id = String(variant.id);
    if (select.value !== id) {
      select.value = id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function renderSizePicker(block, product) {
    var media = block.querySelector('.rebuy-product-media');
    if (!media) return null;

    var opt = sizeOption(product);
    var values = opt && Array.isArray(opt.values) ? opt.values : [];
    // Skip single-variant / membership-style products
    if (values.length <= 1) {
      var existing = block.querySelector('.fm-rebuy-size-picker');
      if (existing) existing.remove();
      return null;
    }
    if (/membership/i.test(product.title || '')) {
      var existingMem = block.querySelector('.fm-rebuy-size-picker');
      if (existingMem) existingMem.remove();
      return null;
    }

    var picker = block.querySelector('.fm-rebuy-size-picker');
    var prev = picker
      ? (picker.querySelector('input:checked') || {}).value
      : null;

    if (!picker) {
      picker = document.createElement('div');
      picker.className = 'fm-rebuy-size-picker';
      media.appendChild(picker);
    }

    var uid = block.getAttribute('data-fm-uid');
    if (!uid) {
      uid = Math.random().toString(36).slice(2, 8);
      block.setAttribute('data-fm-uid', uid);
    }
    var inputName = 'fm-rebuy-' + product.id + '-' + uid + '-size';

    var defaultValue = prev;
    if (!defaultValue || values.indexOf(defaultValue) === -1) {
      defaultValue =
        values.find(function (v) {
          return valueAvailable(product, v);
        }) || values[0];
    }

    var html = '<div class="fm-rebuy-size-picker__row" role="radiogroup" aria-label="Size">';
    for (var i = 0; i < values.length; i++) {
      var val = values[i];
      var id = inputName + '-' + i;
      var available = valueAvailable(product, val);
      var checked = val === defaultValue ? ' checked' : '';
      var disabled = available ? '' : ' disabled';
      html +=
        '<input class="fm-rebuy-size-picker__input" type="radio" name="' +
        inputName +
        '" id="' +
        id +
        '" value="' +
        String(val).replace(/"/g, '&quot;') +
        '"' +
        checked +
        disabled +
        ' />' +
        '<label class="fm-rebuy-size-picker__label" for="' +
        id +
        '">' +
        String(val).replace(/</g, '&lt;') +
        '</label>';
    }
    html += '</div>';
    picker.innerHTML = html;
    return picker;
  }

  function applyPrice(block, product, variant) {
    var priceEl = block.querySelector('.rebuy-product-price');
    if (!priceEl) return;
    var cents = variant && variant.price != null ? variant.price : product.price;
    var pricing = resolvePricing(product);
    priceEl.innerHTML = buildPriceHtml(cents, pricing);
  }

  function applySourceLine(block, product) {
    var info = block.querySelector('.rebuy-product-info');
    if (!info) return;
    var existing = info.querySelector('.fm-rebuy-factory');
    var line = product && product.source_line;
    if (line != null) line = String(line).replace(/\s+/g, ' ').trim();
    if (!line) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'fm-rebuy-factory';
      info.appendChild(existing);
    }
    existing.textContent = line;
  }

  function applyCta(block, product, variant) {
    var btn =
      block.querySelector('.rebuy-product-actions .rebuy-button:not(.outline)') ||
      block.querySelector('.rebuy-product-actions button');
    if (!btn) return;

    var cta = resolveCta(product, variant);
    btn.setAttribute('data-fm-cta', cta.state);
    btn.classList.toggle('join-button', cta.state === 'member-exclusive');
    btn.classList.toggle('button--member-exclusive', cta.state === 'member-exclusive');
    btn.disabled = cta.state === 'sold-out';

    if (variant && variant.id) {
      block.setAttribute('data-fm-variant-id', String(variant.id));
    }

    if (cta.state === 'preorder' && cta.url) {
      btn.setAttribute('data-fm-preorder-url', cta.url);
    } else {
      btn.removeAttribute('data-fm-preorder-url');
    }

    syncRebuySelect(block, variant);
  }

  function addToCart(variantId, btn) {
    if (!variantId) return Promise.resolve();
    if (btn) btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // Open theme cart notification if present
        var note = document.querySelector('cart-notification');
        if (note && typeof note.open === 'function') {
          fetch(root + 'cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              if (typeof note.renderContents === 'function') note.renderContents(cart);
              else note.open();
            })
            .catch(function () {});
        }
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  function onBlockClick(event) {
    var btn = event.target.closest('.rebuy-product-actions .rebuy-button, .rebuy-product-actions button');
    if (!btn || !btn.closest('.rebuy-product-block')) return;

    var block = btn.closest('.rebuy-product-block');
    var state = btn.getAttribute('data-fm-cta');

    if (state === 'preorder') {
      var url = btn.getAttribute('data-fm-preorder-url');
      if (url) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        window.location.href = url;
      }
      return;
    }
    if (state === 'member-exclusive') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (typeof window.openMembershipPopup === 'function') {
        window.openMembershipPopup(event);
      }
      return;
    }
    if (state === 'sold-out') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return;
    }
    if (state === 'quick-buy') {
      var variantId = block.getAttribute('data-fm-variant-id');
      // Always drive ATC from our selected size — Rebuy may not know about FM picker
      if (variantId) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        addToCart(variantId, btn).catch(function () {});
      }
    }
  }

  function applyOverlayStyles(el, bottom) {
    if (!el) return;
    // Inline beats Rebuy CDN stylesheet load order
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('left', '2%', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('bottom', bottom, 'important');
    el.style.setProperty('width', '96%', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('z-index', '5', 'important');
    el.style.setProperty('transition', 'opacity 0.2s ease', 'important');
  }

  function setOverlayVisibility(block, visible) {
    var picker = block.querySelector('.fm-rebuy-size-picker');
    var actions = block.querySelector('.rebuy-product-actions');
    var val = visible ? '1' : '0';
    var pe = visible ? 'auto' : 'none';
    [picker, actions].forEach(function (el) {
      if (!el) return;
      el.style.setProperty('opacity', val, 'important');
      el.style.setProperty('pointer-events', pe, 'important');
      el.style.setProperty('visibility', visible ? 'visible' : 'hidden', 'important');
    });
  }

  /**
   * Nest FM size picker + Rebuy actions into .rebuy-product-media (PLP overlay).
   */
  function nestQuickAdd(block) {
    var media = block.querySelector('.rebuy-product-media');
    if (!media) return;

    media.style.setProperty('position', 'relative', 'important');
    media.style.setProperty('overflow', 'hidden', 'important');
    media.style.setProperty('width', '100%', 'important');

    var imageBox =
      media.querySelector('.rebuy-product-image, .rebuy-product-image-trigger') || media;
    if (imageBox !== media) {
      imageBox.style.setProperty('display', 'block', 'important');
      imageBox.style.setProperty('width', '100%', 'important');
      imageBox.style.setProperty('aspect-ratio', '3 / 4', 'important');
      imageBox.style.setProperty('position', 'relative', 'important');
      imageBox.style.setProperty('overflow', 'hidden', 'important');
    }

    var imgs = media.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.setProperty('position', 'absolute', 'important');
      imgs[i].style.setProperty('inset', '0', 'important');
      imgs[i].style.setProperty('width', '100%', 'important');
      imgs[i].style.setProperty('height', '100%', 'important');
      imgs[i].style.setProperty('max-width', 'none', 'important');
      imgs[i].style.setProperty('object-fit', 'cover', 'important');
      imgs[i].style.setProperty('object-position', 'center top', 'important');
    }

    // Hide Rebuy's native variant UI — FM picker owns size selection
    var rebuyOptions = block.querySelectorAll('.rebuy-product-options');
    for (var r = 0; r < rebuyOptions.length; r++) {
      rebuyOptions[r].style.setProperty('display', 'none', 'important');
    }

    var picker = block.querySelector('.fm-rebuy-size-picker');
    var actions = block.querySelector('.rebuy-product-actions');
    if (picker && picker.parentElement !== media) media.appendChild(picker);
    if (actions && actions.parentElement !== media) media.appendChild(actions);

    applyOverlayStyles(actions, '2%');
    applyOverlayStyles(picker, 'calc(2% + 4.8rem)');

    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      [picker, actions].forEach(function (el) {
        if (!el) return;
        el.style.setProperty('display', 'none', 'important');
      });
    } else {
      if (actions) actions.style.setProperty('display', 'block', 'important');
      if (picker) picker.style.setProperty('display', 'block', 'important');
      setOverlayVisibility(block, block.matches(':hover'));
    }
  }

  function applyCollectionBadge(block, product) {
    var host =
      block.querySelector('.rebuy-product-media') ||
      block.querySelector('.rebuy-product-image, .rebuy-product-image-trigger');
    if (!host) return;

    var existing = block.querySelector('.badge_element');
    var label = product && product.collection_badge;
    if (label != null) label = String(label).trim();
    if (!label) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'badge_element';
      host.appendChild(existing);
    } else if (existing.parentElement !== host) {
      host.appendChild(existing);
    }
    existing.textContent = label.toUpperCase();
  }

  function hideReviewChrome(block) {
    var nodes = block.querySelectorAll(
      '.rebuy-product-review, .rebuy-review, .powered-by-reviews, a[href*="review"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].style.display = 'none';
    }
    // Text-node links Rebuy sometimes injects ("Review This Product")
    var links = block.querySelectorAll('a');
    for (var j = 0; j < links.length; j++) {
      var t = (links[j].textContent || '').trim().toLowerCase();
      if (t.indexOf('review') !== -1) links[j].style.display = 'none';
    }
  }

  function bindBlock(block, product) {
    if (block.getAttribute(ENHANCED_ATTR) === '1') return;
    block.setAttribute(ENHANCED_ATTR, '1');

    var syncing = false;
    var sync = function () {
      if (syncing) return;
      syncing = true;
      try {
        upgradeCardImages(block);
        renderSizePicker(block, product);
        nestQuickAdd(block);
        applyCollectionBadge(block, product);
        hideReviewChrome(block);
        var variant = findVariant(product, block);
        applyPrice(block, product, variant);
        applySourceLine(block, product);
        applyCta(block, product, variant);
      } finally {
        syncing = false;
      }
    };

    sync();

    block.addEventListener('mouseenter', function () {
      if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) {
        setOverlayVisibility(block, true);
      }
    });
    block.addEventListener('mouseleave', function () {
      setOverlayVisibility(block, false);
    });
    block.addEventListener('focusin', function () {
      setOverlayVisibility(block, true);
    });
    block.addEventListener('focusout', function (e) {
      if (!block.contains(e.relatedTarget)) setOverlayVisibility(block, false);
    });

    block.addEventListener('change', function (e) {
      if (e.target && e.target.closest('.fm-rebuy-size-picker')) {
        var variant = findVariant(product, block);
        applyPrice(block, product, variant);
        applySourceLine(block, product);
        applyCta(block, product, variant);
      }
    });
    block.addEventListener('click', onBlockClick, true);

    var mo = new MutationObserver(function () {
      if (syncing) return;
      if (!block.querySelector('.fm-rebuy-price') || !block.querySelector('.rebuy-product-actions')) {
        sync();
      } else if (!block.querySelector('.fm-rebuy-size-picker') && sizeOption(product) && (sizeOption(product).values || []).length > 1) {
        sync();
      } else {
        upgradeCardImages(block);
        nestQuickAdd(block);
        applyCollectionBadge(block, product);
        applySourceLine(block, product);
      }
    });
    mo.observe(block, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'data-src']
    });
  }

  function enhanceBlock(block) {
    // Layout first — don't wait on product JSON for the gap / overlay fix
    upgradeCardImages(block);
    nestQuickAdd(block);
    hideReviewChrome(block);

    if (block.getAttribute(ENHANCED_ATTR) === '1') return;
    if (block.getAttribute('data-fm-rebuy-pending') === '1') return;
    var handle = extractHandle(block);
    if (!handle) return;
    block.setAttribute('data-fm-rebuy-pending', '1');
    fetchProduct(handle)
      .then(function (product) {
        block.removeAttribute('data-fm-rebuy-pending');
        bindBlock(block, product);
      })
      .catch(function () {
        block.removeAttribute('data-fm-rebuy-pending');
        /* layout nest already applied; leave OOTB price/CTA */
      });
  }

  function galleryAlignLeft() {
    var img =
      document.querySelector('.product__media-wrapper .product__media-item img') ||
      document.querySelector('.product__media-wrapper img') ||
      document.querySelector('.product__media-wrapper');
    if (!img) return null;
    return Math.round(img.getBoundingClientRect().left);
  }

  function zeroRebuyGutters(widget) {
    var shells = widget.querySelectorAll(
      '.rebuy-widget-container, .rebuy-widget-content, .rebuy-widget-header'
    );
    for (var i = 0; i < shells.length; i++) {
      shells[i].style.setProperty('padding-left', '0', 'important');
      shells[i].style.setProperty('padding-right', '0', 'important');
      shells[i].style.setProperty('margin-left', '0', 'important');
    }
    widget.style.setProperty('padding-left', '0', 'important');
    widget.style.setProperty('margin-left', '0', 'important');
  }

  function clearRebuyAlign(widget) {
    widget.style.removeProperty('padding-left');
    widget.style.removeProperty('padding-right');
    widget.style.removeProperty('margin-left');
  }

  function alignOneWidget(widget, targetLeft) {
    if (!widget) return;
    zeroRebuyGutters(widget);

    var title = widget.querySelector('.primary-title, .super-title');
    if (!title) return;

    var titleShift = targetLeft - Math.round(title.getBoundingClientRect().left);
    if (titleShift > 0) {
      widget.style.setProperty('padding-left', titleShift + 'px', 'important');
      widget.style.setProperty('padding-right', titleShift + 'px', 'important');
    } else if (titleShift < 0) {
      widget.style.setProperty('margin-left', titleShift + 'px', 'important');
    }
  }

  var PEEK_WIDTH = 'calc((100% - 8px) / 2.2)';

  function sizePeekSlides(root, isMobile) {
    var slides = root.querySelectorAll('.splide__slide');
    for (var s = 0; s < slides.length; s++) {
      if (isMobile) {
        slides[s].style.setProperty('width', PEEK_WIDTH, 'important');
        slides[s].style.setProperty('min-width', PEEK_WIDTH, 'important');
        slides[s].style.setProperty('max-width', PEEK_WIDTH, 'important');
        slides[s].style.setProperty('flex', '0 0 ' + PEEK_WIDTH, 'important');
      } else {
        slides[s].style.removeProperty('width');
        slides[s].style.removeProperty('min-width');
        slides[s].style.removeProperty('max-width');
        slides[s].style.removeProperty('flex');
      }
    }
  }

  function applySplideOptions(splide, opts) {
    if (!splide) return;
    try {
      if (typeof splide.options === 'function') {
        splide.options(opts);
        return;
      }
      var key;
      for (key in opts) {
        if (Object.prototype.hasOwnProperty.call(opts, key)) {
          splide.options[key] = opts[key];
        }
      }
      if (typeof splide.refresh === 'function') splide.refresh();
    } catch (e) {}
  }

  function compactPdpCarousels() {
    if (!document.body || !document.body.classList.contains('product')) return;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var widgets = document.querySelectorAll('body.product .rebuy-widget');
    for (var w = 0; w < widgets.length; w++) {
      sizePeekSlides(widgets[w], isMobile);
    }
    var nodes = document.querySelectorAll('body.product .rebuy-widget .splide');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var splide = el.splide;
      var mode = isMobile ? 'peek' : 'default';
      if (splide && el.getAttribute('data-fm-carousel') !== mode) {
        el.setAttribute('data-fm-carousel', mode);
        if (isMobile) {
          applySplideOptions(splide, {
            perPage: 2,
            perMove: 1,
            gap: 8,
            pagination: false,
            arrows: false
          });
        } else if (typeof splide.refresh === 'function') {
          try {
            splide.refresh();
          } catch (e) {}
        }
        sizePeekSlides(el, isMobile);
      }
    }
  }

  var alignRaf = 0;
  var alignTimer = 0;
  function alignRebuyWidgets() {
    var widgets = document.querySelectorAll('.rebuy-widget');
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    compactPdpCarousels();
    if (isMobile) {
      for (var m = 0; m < widgets.length; m++) clearRebuyAlign(widgets[m]);
      return;
    }
    var target = galleryAlignLeft();
    for (var i = 0; i < widgets.length; i++) {
      if (target == null) {
        widgets[i].style.setProperty('padding-left', '5rem', 'important');
        widgets[i].style.setProperty('padding-right', '5rem', 'important');
      } else {
        alignOneWidget(widgets[i], target);
      }
    }
  }

  function scheduleAlign() {
    if (alignRaf) cancelAnimationFrame(alignRaf);
    alignRaf = requestAnimationFrame(function () {
      alignRaf = requestAnimationFrame(alignRebuyWidgets);
    });
    clearTimeout(alignTimer);
    alignTimer = setTimeout(alignRebuyWidgets, 200);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var blocks = scope.querySelectorAll
      ? scope.querySelectorAll('.rebuy-product-block')
      : [];
    if (root && root.classList && root.classList.contains('rebuy-product-block')) {
      enhanceBlock(root);
    }
    for (var i = 0; i < blocks.length; i++) enhanceBlock(blocks[i]);
  }

  function start() {
    scan(document);
    scheduleAlign();
    window.addEventListener('resize', scheduleAlign);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('rebuy-product-block')) {
            enhanceBlock(node);
          } else if (node.querySelectorAll) {
            scan(node);
            if (node.classList.contains('rebuy-widget') || node.querySelector('.rebuy-widget')) {
              scheduleAlign();
            }
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('rebuy:smartcart.ready', function () {
      scan(document);
    });
    document.addEventListener('rebuy:cart.change', function () {
      scan(document);
    });
    document.addEventListener('rebuy.ready', scheduleAlign);
    document.addEventListener('rebuy.widget.init', scheduleAlign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
